import {
    SET_CLIENT_IS_APP
} from '@/store/mutation.types';

export default {
    state: () => ({
        isApp: false
    }),

    actions: {
        setClientIsApp: ({ commit }, isApp) => {
            commit(SET_CLIENT_IS_APP, isApp);
        }
    },

    mutations: {
        [SET_CLIENT_IS_APP]: (state, isApp) => {
            state.isApp = !!isApp;
        }
    }
};
